import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'
import {toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBInput,
  MDBContainer,
  MDBRow,
  MDBValidation,
  MDBValidationItem,
  MDBCardTitle,
  MDBCardText


}
from 'mdb-react-ui-kit';
import '../../../css/index.css';
import SearchBar from '../../searchBar/searchBar';



function CriarAluno() {
  const navigate = useNavigate();

  const util = require('../../../utils/index');
  const userLogin = util.getUser();
  const api = require('../../../apis/turma')
  const apiAluno = require('../../../apis/aluno');

  const obj = util.decideBody(userLogin)

  const handleSubmit = async (values) => {
    const obj = ({
      ...formValue,
      nomeTurma: inputSearch,
      codTurma: inputSearchCodTurma,
      idFilial: userLogin.idfilial || '1',
      idEscola: userLogin.idescola || '80'
    })

    values.preventDefault();
    util.isSubmitting()
    const result = await apiAluno.registrarAlunoApi(obj);
    result ? toast.success("Criado com sucesso!") && navigate("/area-aluno") : null;
    util.isSubmitting()
    
  }

  const [filterSearch, setFilterSearch] = useState([]);
  const [inputSearch, setInputSearch] = useState("");
  const [inputSearchCodTurma, setInputSearchCodTurma] = useState("");
  const [dataApi, setDataApi] = useState([]);
;
  const [formValue, setFormValue] = useState({
    ra: '',
    nomeAluno: ''
  });
  
  const tipo = {
    turma: "turma",
    responsavel: "responsavel"
  }
  const onChange = (e) => {
    setFormValue({ ...formValue, [e.target.name]: e.target.value });
  };

  const onBlur = (e) => {
    setFormValue({ ...formValue, [e.target.name]: e.target.value });
  };

  const handleOnChangeTurma = (e) => {
    try{
      setInputSearch(e.target.value);
      const newFilter = dataApi.filter(value =>{
        return value.nometurma.toLowerCase().includes(inputSearch.toLowerCase())
      });
      setFilterSearch(newFilter);
    }catch(e){
      toast.error(e);
    }
  }

  const handleClickTurma = (e) => {
    setInputSearch(e.nometurma);
    setInputSearchCodTurma(e.codturma)
    setFilterSearch([]);
  }

  useEffect(()=>{
    if(inputSearch === ""){
      setFilterSearch([]);
    }
  }, [inputSearch])

  useEffect(() => {
const getClasses = async () => {
      try {
        const object = {
          idFilial: userLogin.idfilial,
          idEscola: userLogin.idescola
        };
        const response = await api.listarTurmaApi(object);
        const data = await response;
        setDataApi(data);
        
      } catch (error) {
        console.error('Erro ao obter dados:', error);
      }
    };
getClasses();
    
  }, []);
  return (
    <MDBContainer fluid className=' background-radial-gradient' style={{
      height:"100vh",minHeight:'500px',display:"flex", justifyContent:"center", alignContent:"center"
      
      }}>
      <MDBRow center className='w-100 d-flex flex-column align-items-center'>

          <MDBCard className='bg-dark text-white h-75 w-75' style={{borderRadius: '1rem', minWidth: '300px'}}>
              <MDBCardBody className='d-flex flex-column align-items-center'>

              <MDBCardTitle className='text-white my-4'>Bem vindo, {util.decideName(userLogin)}</MDBCardTitle>
                  <MDBValidation className='w-100' onSubmit={handleSubmit}>
                    <div className='d-flex justify-content-between'>
                    <MDBValidationItem style={{width:'45%'}} feedback='Por favor digite uma senha válida!' invalid>
                        <MDBInput 
                          wrapperClass='mb-5 w-100' 
                          labelClass='text-white' 
                          label='Nome' id='formControNomeAluno' 
                          type='text' 
                          size="lg" 
                          style={{color:"white"}}
                          name='nomeAluno'
                          value={formValue.nomeAluno || ''}
                          onChange={onChange}
                          onBlur={onBlur} 
                          required
                          minLength={3}
                          
                          />
                        
                      </MDBValidationItem>
                      <MDBValidationItem style={{width:'45%'}} feedback='Por favor digite seu nome!' invalid>
                        <MDBInput 
                          wrapperClass='mb-5 w-100' 
                          labelClass='text-white' 
                          label='RA' 
                          name='ra'
                          id='formControRa' 
                          type='text' 
                          size="lg"
                          value={formValue.ra || ''}
                          onChange={onChange}
                          onBlur={onBlur} 
                          required
                          style={{color:"white"}}/>
                      </MDBValidationItem >
                    
                    </div>
                    <div className='d-flex justify-content-between'>
                      <MDBValidationItem style={{width:'45%'}} feedback='Por favor digite seu nome!' invalid>
                        <MDBInput 
                          wrapperClass='w-100' 
                          labelClass='text-white' 
                          label='Turma' 
                          name='ra'
                          id='formControRa' 
                          type='text' 
                          size="lg"
                          value={inputSearch || ''}
                          onChange={handleOnChangeTurma}
                          required
                          style={{color:"white"}}/>
                          
                        
                      {filterSearch !== 0 &&<SearchBar data={filterSearch} handleClick={handleClickTurma} tipo={tipo.turma}/>}
                      </MDBValidationItem >
                      <MDBValidationItem style={{width:'45%', opacity:0.4}} feedback='Por favor digite uma senha válida!' invalid>
                        <MDBInput 
                          wrapperClass='mb-5 w-100' 
                          className='bg-dark'
                          labelClass='text-white' 
                          label='Codigo da turma' id='formControCodTurma' 
                          type='text' 
                          size="lg" 
                          style={{color:"white"}}
                          name='codTurma'
                          value={inputSearchCodTurma || ''}
                          onChange={onChange}
                          onBlur={onBlur} 
                          required
                          minLength={3}
                          disabled={true}
                          />
                        
                      </MDBValidationItem>
                    </div>
                      <MDBBtn 
                        outline 
                        className='px-5 w-100 btn-home' 
                        color='white' 
                        size='lg'
                        type='submit'   
                        id='submitForm'  
                        //disabled={formValue.senha.length < 3 || formValue.nomeAdministrador.length < 1 || formValue.login.length < 1}                 
                        >
                        
                        Registrar
                      </MDBBtn>
                      <MDBBtn 
                        outline 
                        className='px-5 w-100 mt-4 btn-home' 
                        color='white' 
                        size='sm'
                        type='submit'   
                        onClick={() => {
                          navigate("/area-aluno")
                        }}
                        >
                        
                        Voltar
                      </MDBBtn>
                  </MDBValidation>
              </MDBCardBody>
          </MDBCard>
      </MDBRow>

    </MDBContainer>
  );
}

export default CriarAluno;
